import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BtnDefault } from "../../../../components/buttons/BtnDefault";
import { Header } from "../../../../components/Header";
import { DashboardLayout } from "../../../../components/layouts/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { useHookWaTemplate } from "../../../../hooks/useHookWaTemplate";

// --- Data Dummy untuk Demonstrasi ---
const categories = [
  { id: "invoice", label: "Invoice" },
  { id: "tiket_gangguan", label: "Tiket Gangguan" },
  { id: "broadcast_gangguan", label: "Broadcast Gangguan" },
  { id: "broadcast_promo", label: "Broadcast Promo" },
];

const dummyTemplates = [
  {
    id: 1,
    title: "Tagihan Bulanan ISP",
    category: "invoice",
    content: "Halo {nama_customer}, berikut adalah rincian tagihan internet Anda untuk bulan ini sebesar {jumlah}. Mohon segera melakukan pembayaran. Terima kasih.",
    lastUpdated: "2 Jam yang lalu"
  },
  {
    id: 2,
    title: "Konfirmasi Pembayaran",
    category: "invoice",
    content: "Terima kasih, pembayaran Anda telah kami terima. Status layanan internet Anda kembali aktif.",
    lastUpdated: "1 Hari yang lalu"
  },
  {
    id: 3,
    title: "Laporan Gangguan Diterima",
    category: "tiket_gangguan",
    content: "Halo, laporan gangguan dengan Tiket #{no_tiket} telah kami terima. Teknisi kami akan segera memproses laporan Anda.",
    lastUpdated: "30 Menit yang lalu"
  },
  {
    id: 4,
    title: "Maintenance Wilayah",
    category: "broadcast_gangguan",
    content: "Pemberitahuan: Kami akan melakukan maintenance jaringan di wilayah {area} pada tanggal {tanggal}. Layanan mungkin akan terganggu sementara.",
    lastUpdated: "5 Hari yang lalu"
  },
  {
    id: 5,
    title: "Promo Paket Upgrade Speed",
    category: "broadcast_promo",
    content: "🔥 SPESIAL UNTUK ANDA! Upgrade kecepatan internet Anda sekarang dan dapatkan diskon 50% untuk 3 bulan pertama. Hubungi kami segera!",
    lastUpdated: "1 Minggu yang lalu"
  }
];

export const WhatsAppTemplatePage = () => {
    const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeCategory, setActiveCategory] = useState("invoice");

  const {data, loading, refreshData} = useHookWaTemplate();

  // Filter template berdasarkan kategori yang aktif
  const filteredTemplates = dummyTemplates.filter(
    (item) => item.category === activeCategory
  );

  return (
    <>
      <Helmet>
        <title>Template Pesan - DANELA NET</title>
        <meta
          name="description"
          content="Kelola template pesan WhatsApp untuk invoice, tiket gangguan, dan broadcast."
        />
      </Helmet>

      <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
        {/* ===== Header ===== */}
        <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
          <div className="flex flex-col md:flex-row md:items-center justify-between w-full gap-4">
            <h2 className="text-xl font-bold text-gray-100">Template Pesan</h2>
            <BtnDefault onClick={() => navigate('/dashboard/whatsapp/template/create')}>
              <span>+ Buat Template Baru</span>
            </BtnDefault>
          </div>
        </Header>

        <main className="p-4 lg:p-6 space-y-6">
          
          {/* ===== Category Tabs ===== */}
          <div className="border-b border-gray-700">
            <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`
                    whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200
                    ${
                      activeCategory === cat.id
                        ? "border-blue-500 text-blue-400"
                        : "border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-500"
                    }
                  `}
                >
                  {cat.label}
                </button>
              ))}
            </nav>
          </div>

          {/* ===== Template List ===== */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {data.length > 0 ? (
              data.map((item) => (
                <div 
                  key={item?.id}
                  className="bg-gray-800 rounded-lg border border-gray-700 p-5 hover:border-gray-600 transition-colors shadow-sm group"
                >
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-lg font-semibold text-gray-100">
                      {item?.name}
                    </h3>
                    <span className="text-xs bg-gray-700 text-gray-300 px-2 py-1 rounded">
                      {item?.category?.name.replace('_', ' ')}
                    </span>
                  </div>
                  
                  <p className="text-gray-400 text-sm mb-4 line-clamp-3 min-h-[60px]">
                    {item?.body}
                  </p>

                  <div className="flex items-center justify-between pt-4 border-t border-gray-700">
                    <span className="text-xs text-gray-500">
                      Update: {item?.lastUpdated}
                    </span>
                    <div className="flex gap-2 opacity-100 lg:opacity-0 group-hover:opacity-100 transition-opacity">
                      <button 
                        className="text-xs text-blue-400 hover:text-blue-300 font-medium"
                        onClick={() => alert("Edit template: " + item?.id)}
                      >
                        Edit
                      </button>
                      <button 
                        className="text-xs text-red-400 hover:text-red-300 font-medium"
                        onClick={() => alert("Hapus template: " + item?.id)}
                      >
                        Hapus
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full py-10 text-center text-gray-500 bg-gray-800 rounded-lg border border-gray-700 border-dashed">
                <p>Belum ada template untuk kategori ini.</p>
              </div>
            )}
          </div>

        </main>
      </DashboardLayout>
    </>
  );
};